import { db, doc, setDoc, getDoc } from './firebase';

// Generate or retrieve a user ID
const getUserId = () => {
  let userId = localStorage.getItem('userId');
  if (!userId) {
    userId = Math.random().toString(36).substring(2, 15);
    localStorage.setItem('userId', userId);
  }
  return userId;
};

const userId = getUserId();

export const getGameProgress = async () => {
  try {
    const docRef = doc(db, 'gameProgress', userId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data();
    }
    return { completedLevels: [], bricks: 0, houseStages: 0 };
  } catch (error) {
    console.error('Error fetching game progress:', error);
    return { completedLevels: [], bricks: 0, houseStages: 0 };
  }
};

export const saveGameProgress = async (progress) => {
  try {
    const docRef = doc(db, 'gameProgress', userId);
    await setDoc(docRef, progress);
  } catch (error) {
    console.error('Error saving game progress:', error);
  }
};

export const stageCosts = [5, 10, 15, 20, 25];